import { combineReducers } from '@reduxjs/toolkit';

import pointFormReducer from './create-point';
import denmFormReducer from './manage-denm';
import ivimFormReducer from './manage-ivim';
import managePmvFormReducer from './manage-pmv';
import rsuFormReducer from './manage-rsu';
import manageSpatemRsusFormReducer from './manage-spatem-rsus';

const formReducer = combineReducers({
  'manage-denm': denmFormReducer.reducer,
  'create-ivim': ivimFormReducer.reducer,
  'create-point': pointFormReducer.reducer,
  'manage-rsu': rsuFormReducer.reducer,
  'manage-pmv': managePmvFormReducer.reducer,
  'manage-spatem-rsus': manageSpatemRsusFormReducer.reducer,
});

export default formReducer;
